import * as React from 'react';
import s from './Group.scss';
import { FeatureRow } from './FeatureRow';
import { useTranslation } from 'react-i18next';
import { Text, Box } from '@wix/design-system';
import { AdvancedPlansProductData, FeaturesGroupSection } from 'types';
import PaidOnlineBusinessLogo from '../../../../assets/images/groups-icons/get-paid-online-business.svg';
import GrowYourOnlinePresenceWebsite from '../../../../assets/images/groups-icons/grow-your-online-presence-website.svg';
import LookProfessionalBusiness from '../../../../assets/images/groups-icons/look-professional-business.svg';
import LookProfessionalWebsite from '../../../../assets/images/groups-icons/look-professional-website.svg';
import PromoteAndGrowYourSiteBusiness from '../../../../assets/images/groups-icons/promote-and-grow-your-site-business.svg';
import PromoteYourBrandWebsite from '../../../../assets/images/groups-icons/promote-your-brand-website.svg';
import DayfulEngageClients from '../../../../assets/images/groups-icons/engage-clients.svg';
import DayfulEnhancePayment from '../../../../assets/images/groups-icons/enhance-payment.svg';
import DayfulManageSchedule from '../../../../assets/images/groups-icons/manage-schedule.svg';
import DayfulStreamlineDay from '../../../../assets/images/groups-icons/streamline-day.svg';
import DayfulSupport from '../../../../assets/images/groups-icons/support.svg';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { featureRowDataHooks as dataHooks } from './FeatureRow.datahooks';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from '../../../../providers';
import { observer } from 'mobx-react';

interface GroupProps extends InjectedExperimentsProps {
  products: AdvancedPlansProductData[];
  group: FeaturesGroupSection;
  rootStore: RootStore;
}

const logos = {
  'get-paid-online-business': <PaidOnlineBusinessLogo />,
  'grow-your-online-presence-website': <GrowYourOnlinePresenceWebsite />,
  'look-professional-business': <LookProfessionalBusiness />,
  'look-professional-website': <LookProfessionalWebsite />,
  'promote-and-grow-your-site-business': <PromoteAndGrowYourSiteBusiness />,
  'promote-your-brand-website': <PromoteYourBrandWebsite />,
  'engage-clients': <DayfulEngageClients />,
  'enhance-payment': <DayfulEnhancePayment />,
  'manage-schedule': <DayfulManageSchedule />,
  'streamline-day': <DayfulStreamlineDay />,
  'clock-support': <DayfulSupport />,
};

export const GroupComp: React.FC<GroupProps> = ({
  group,
  products,
  experiments,
  rootStore,
}) => {
  const { t } = useTranslation();
  const showGroupIcon =
    !rootStore.appStore.isSunriseV2Enabled && group.icon && logos[group.icon];
  const isMediumTableViewMode = rootStore.appStore.isMediumSizeTableView;

  return (
    <div
      className={classNames(s.groupWrapper, {
        [s.groupMediumView]: isMediumTableViewMode,
      })}
      data-hook={dataHooks.group}
    >
      <div className={s.groupHeader}>
        {showGroupIcon && (
          <Box dataHook={dataHooks.groupIcon} data-testid={dataHooks.groupIcon}>
            {logos[group.icon!]}
          </Box>
        )}
        <Text weight='bold'>{t(group.translationKey)}</Text>
      </div>
      <div className={s.groupSubgrid}>
        {group.features.map((feature, idx) => (
          <FeatureRow
            key={idx}
            products={products}
            feature={feature}
            cellClassName={s.groupCell}
          />
        ))}
      </div>
    </div>
  );
};

export const Group = withInjectedRootStore(
  observer(withExperiments(GroupComp)),
);
